module.exports = __webpack_public_path__ + "static/media/Serendipity_Wide.fcde15b2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Serendipity_Wide.eot
// module id = 1486
// module chunks = 44